import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgUpward({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.98 2h.04a1.002 1.002 0 01.129.01l.052.01a.945.945 0 01.32.126c.025.016.05.032.074.05l.013.01c.034.026.068.055.1.087l-.091-.08.036.029-.036-.03c.031.025.062.052.09.08l9 9.001a1 1 0 01-1.32 1.498l-.094-.084L13 5.413V21a1 1 0 01-.883.993L12 22a1 1 0 01-.993-.884L11 21V5.414l-7.293 7.293a1 1 0 01-1.32.084l-.094-.084a1 1 0 010-1.414l9-9a1.004 1.004 0 01.559-.282l.066-.008.023-.001.005-.001.035-.001zm.727.293a.999.999 0 00-.112-.097l.035.028.077.069z"
        fill={color}
      />
    </svg>
  )
}

export default SvgUpward
